// Kampanya Textleri Multiple Animasyonu
document.addEventListener('DOMContentLoaded', function () {
    const carousels =
        document.querySelectorAll('.hp-cart-discount-carousel');

    carousels.forEach(function (carousel) {
        const textsCount = parseInt(carousel.dataset.textsCount);
        if (!textsCount || textsCount <= 1) return;

        const texts = carousel.querySelectorAll('.hp-cart-discount-text');
        let currentIndex = 0;

        function showNextText() {
            // Hide current text
            texts[currentIndex].style.transform = 'translateY(-100%)';

            // Show next text
            currentIndex = (currentIndex + 1) % textsCount;
            texts[currentIndex].style.transform = 'translateY(0%)';

            // Hide other texts
            texts.forEach(function (text, index) {
                if (index !== currentIndex) {
                    if (index < currentIndex) {
                        text.style.transform = 'translateY(-100%)';
                    } else {
                        text.style.transform = 'translateY(100%)';
                    }
                }
            });
        }

        // Start rotation every 5 seconds
        setInterval(showNextText, 5000);
    });
});